import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, type RegisteredIssuer } from "../api/client";
import { NameBasisBadge } from "../components/NameBasisBadge";

const MODE: Record<string, string> = { platform: "Platform signing", "self-hosted": "Self-hosted signing" };
const PROOF: Record<string, string> = { domain_second_person: "Domain + second person" };

/** /orgs: every organisation in the public directory, with counts only. */
export function OrgsPage() {
  const [orgs, setOrgs] = useState<RegisteredIssuer[] | null>(null);
  useEffect(() => { api.GET("/registry/issuers").then((r) => setOrgs((r.data?.issuers ?? []).filter((i) => i.listed !== false))); }, []);
  if (!orgs) return <p className="note">Loading…</p>;
  const full = orgs.filter((o) => o.kind === "full"), light = orgs.filter((o) => o.kind === "light");
  const Row = ({ o }: { o: RegisteredIssuer }) => (
    <li className="card org" data-testid="org" data-kind={o.kind}>
      <div className="row" style={{ justifyContent: "space-between" }}>
        <span><Link to={`/issuer/${encodeURIComponent(o.did)}`}><b>{o.name}</b></Link>
          {o.kind === "full" && <NameBasisBadge basis={o.name_basis} domain={o.domain} />}</span>
        {o.kind === "full" && o.signing_mode && <span className="badge" data-testid="org-badge">{MODE[o.signing_mode.mode] ?? o.signing_mode.mode}</span>}
        {o.kind === "light" && <span className="badge" data-testid="org-badge">{PROOF[o.proof_type ?? ""] ?? o.proof_type ?? "Light issuer"}</span>}
      </div>
      {o.domain && <div className="hint">{o.domain}</div>}
      {o.counts && <div className="hint" data-testid="org-counts">{o.counts.anchored.toLocaleString()} claims anchored · {o.counts.confirmed.toLocaleString()} confirmed</div>}
    </li>
  );
  return (
    <div>
      <h1>Organisations</h1>
      <p className="lead">Issuers that chose to be listed, and every organisation that claimed a domain on the rail.</p>
      <h2>Full issuers</h2>
      {full.length ? <ul className="orgs">{full.map((o) => <Row key={o.did} o={o} />)}</ul> : <p className="note">None listed yet.</p>}
      <h2>Light issuers</h2>
      {light.length ? <ul className="orgs">{light.map((o) => <Row key={o.did} o={o} />)}</ul> : <p className="note">None yet.</p>}
    </div>
  );
}
